import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String }

  connect() {
    const toggleButton = this.element.querySelector('[data-toggle-notifications-target="toggleButton"]');
    if (toggleButton) {
      toggleButton.checked = this.element.dataset.status === "true";
    }
  }

  async handleToggle(event) {
    const userId = event.target.dataset.userId;
    const target = event.target.dataset.type;
    const url = `/users/${userId}/${target}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({})
      });

      if (!response.ok) throw new Error("Error al actualizar");

      const data = await response.json();

      event.target.checked = target === "device" ? data.notify_device : data.notify_email;
    } catch (error) {
      console.error("Error:", error);
      event.target.checked = !event.target.checked;
    }
  }
}
